import React from "react";

export default function Footer() {
  return (
    <div id="contactinfo" className="footer w-100 text-white p-2 text-center" style={{backgroundColor: 'black'}}>
      <p className="my-0">Thank you for your time!</p>
      <small className="my-0">
        ©️ 2026{" "}
        <a className="text-white" href="https://www.linkedin.com/in/hecedu/">
          Héctor Magaña
        </a>
      </small>
    </div>
  );
}
